import '@strapi/icons';
export { f as default, A as private_AutoReloadOverlayBlockerProvider, u as private_useAutoReloadOverlayBlocker } from './chunks/index-DAXXa6S8.mjs';
import '@reduxjs/toolkit';
import 'immer';
import 'lodash/get';
import 'lodash/set';
import 'lodash/snakeCase';
import 'pluralize';
import '@sindresorhus/slugify';
import 'lodash/cloneDeep';
import 'yup';
import 'react/jsx-runtime';
import 'react';
import '@strapi/design-system';
import 'react-dom';
import 'react-intl';
import 'styled-components';
//# sourceMappingURL=index.mjs.map
